// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de mathématiques
// https://ifpc-fwb.be/v5/documents/tc/refMATH.pdf
// SHA-256 6512078c89102f53f6f90aa14877cfa0d0a7804dce34f5dc6569ef92510848c9
// P3: pages 48-62, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "MATH-P3-659c4436",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir",
    parent: "Les visions de l’espace.",
    text: "Utiliser le vocabulaire exprimant des positions absolues : à côté de, contre, à l’intérieur, à l’extérieur, entre, sous, sur, dans, hors, autour de, face à face, dos à dos.",
  },
  {
    id: "MATH-P3-357157d3",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir",
    parent: "Les visions de l’espace.",
    text: "Utiliser le vocabulaire exprimant des positions relatives (liées au regard) : devant, derrière, à droite, à gauche, en haut, en bas, au-dessus, en dessous, en face de.",
  },
  {
    id: "MATH-P3-619211a3",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir",
    parent: "Les visions de l’espace.",
    text: "Utiliser le vocabulaire exprimant des positions ordinales : - premier, deuxième, troisième... dernier ; - au début, à la fin, avant, après.",
  },
  {
    id: "MATH-P3-593dd0f1",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir",
    parent: "Les déplacements.",
    text: "Utiliser le vocabulaire décrivant un déplacement, tel que : monter, descendre, avancer, reculer, s’éloigner, se rapprocher, faire demi-tour…",
  },
  {
    id: "MATH-P3-87eb1a92",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir",
    parent: "Les systèmes de repérage : du quadrillage au repère orthonormé.",
    text: "Utiliser le vocabulaire lié aux quadrillages : colonnes, lignes et cases.",
  },
  {
    id: "MATH-P3-93474bd6",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir-faire",
    parent: "Situer, placer un objet ou soi-même.",
    text: "Situer (exprimer la position absolue, relative ou ordinale) un objet ou soi-même avec le vocabulaire adéquat : - dans l’espace 3D (réel, vécu, miniaturisé) et 2D (dessin, croquis, photo, plan) ; - selon le point de vue de l’élève ou d’un(e) autre personnage/personne.",
  },
  {
    id: "MATH-P3-8643b017",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir-faire",
    parent: "Situer, placer un objet ou soi-même.",
    text: "Placer un objet/soi-même selon des consignes données ou un modèle observé dans l’espace 3D (réel, vécu, miniaturisé) et 2D (dessin, croquis, photo, plan).",
  },
  {
    id: "MATH-P3-dccfac5d",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir-faire",
    parent: "Déplacer un objet ou soi-même.",
    text: "Se déplacer ou déplacer un objet dans l’espace 3D (réel, vécu, miniaturisé) en suivant des consignes orales.",
  },
  {
    id: "MATH-P3-99e5c3e6",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir-faire",
    parent: "Déplacer un objet ou soi-même.",
    text: "Expliquer oralement un déplacement à l’aide du vocabulaire adéquat, en identifiant des points de repère. Tracer, sur un plan, un déplacement vécu.",
  },
  {
    id: "MATH-P3-6c2c5d33",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir-faire",
    parent: "Situer, placer un objet dans un quadrillage.",
    text: "Situer (exprimer la position) un objet dans un quadrillage codé ou non codé.",
  },
  {
    id: "MATH-P3-2e80a546",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Savoir-faire",
    parent: "Situer, placer un objet dans un quadrillage.",
    text: "Placer des objets dans un quadrillage codé ou non codé, selon des consignes données ou un modèle observé.",
  },
  {
    id: "MATH-P3-0a8f0b45",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.1. (Se) repérer et communiquer des positionnements ou des déplacements",
    kind: "Compétence",
    parent: "Lire, interpréter des représentations de l’espace et les confronter au réel.",
    text: "Repérer, sur le plan local de l’environnement proche élaboré sur quadrillage, des points de repère observés lors d’un déplacement et y indiquer l’itinéraire suivi.",
  },
  {
    id: "MATH-P3-87306522",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les figures, leurs composantes, leurs caractéristiques et leurs propriétés.",
    text: "Identifier : - des quadrilatères : carré, rectangle ; - des triangles : rectangles, isocèles, équilatéraux ; - un cercle.",
  },
  {
    id: "MATH-P3-9f2748cd",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les figures, leurs composantes, leurs caractéristiques et leurs propriétés.",
    text: "Identifier les composantes des figures travaillées : côtés (longueur, largeur), sommets, angles (droits).",
  },
  {
    id: "MATH-P3-2e95c01f",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les figures, leurs composantes, leurs caractéristiques et leurs propriétés.",
    text: "Énoncer des caractéristiques des figures travaillées : le nombre de côtés, les côtés isométriques, le nombre d’angles (droits), les angles isométriques.",
  },
  {
    id: "MATH-P3-506bbf40",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les figures, leurs composantes, leurs caractéristiques et leurs propriétés.",
    text: "Identifier diagonale, médiane, axe de symétrie.",
  },
  {
    id: "MATH-P3-51f2408a",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les figures, leurs composantes, leurs caractéristiques et leurs propriétés.",
    text: "Énoncer les propriétés des diagonales et des médianes d’un carré et d’un rectangle.",
  },
  {
    id: "MATH-P3-67b925d1",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les solides, leurs composantes, leurs caractéristiques et leurs représentations planes.",
    text: "Identifier cube, parallélépipède rectangle, cylindre, sphère, cône, pyramide.",
  },
  {
    id: "MATH-P3-b9005989",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les solides, leurs composantes, leurs caractéristiques et leurs représentations planes.",
    text: "Identifier les composantes des solides travaillés : faces, arêtes, sommets.",
  },
  {
    id: "MATH-P3-3f38f1f5",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Les solides, leurs composantes, leurs caractéristiques et leurs représentations planes.",
    text: "Énoncer des caractéristiques des solides travaillés : nombre de faces, forme des faces, des faces isométriques.",
  },
  {
    id: "MATH-P3-49d99de2",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Construire des solides et des figures avec du matériel varié.",
    text: "Reproduire des cubes et des parallélépipèdes rectangles à partir de modèles 3D donnés, avec du matériel géométrique varié (faces à attacher, tiges et boules à assembler…).",
  },
  {
    id: "MATH-P3-cf824211",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Construire des solides et des figures avec du matériel varié.",
    text: "Reproduire et construire les polygones travaillés par découpage, par pliage et avec du matériel varié.",
  },
  {
    id: "MATH-P3-736cfe2d",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Construire des solides et des figures avec du matériel varié.",
    text: "Construire un angle droit par pliage.",
  },
  {
    id: "MATH-P3-9aa4ade3",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Tracer des figures.",
    text: "Utiliser l’équerre pour tracer un angle droit sur papier vierge.",
  },
  {
    id: "MATH-P3-94733210",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Tracer des figures.",
    text: "Tracer un rectangle, un carré, un triangle (excepté le triangle équilatéral) à la latte sur papier tramé, avec et sans contraintes.",
  },
  {
    id: "MATH-P3-87525da6",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Tracer des figures.",
    text: "Tracer un triangle inscrit dans un carré ou un rectangle.",
  },
  {
    id: "MATH-P3-9dc9f760",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Tracer des axes de symétrie, des diagonales, des médianes et des hauteurs.",
    text: "Matérialiser par pliage d’un rectangle ou d’un carré : - les axes de symétrie ; - les médianes et diagonales.",
  },
  {
    id: "MATH-P3-8a33284f",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Tracer des axes de symétrie, des diagonales, des médianes et des hauteurs.",
    text: "Comparer les traits résultants d’un pliage pour les diagonales et/ ou les médianes d’un carré ou d’un rectangle avec ceux des axes de symétrie.",
  },
  {
    id: "MATH-P3-79297eb5",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Comparer des figures.",
    text: "Comparer les caractéristiques (selon les côtés et les angles) : - d’un carré et d’un rectangle ; - de deux triangles.",
  },
  {
    id: "MATH-P3-b6d5fc18",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Établir des relations entre des objets en 3D et leurs représentations en 2D.",
    text: "Reconnaitre les figures possibles correspondant aux faces des solides observés.",
  },
  {
    id: "MATH-P3-ea9bf7a1",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Établir des relations entre des objets en 3D et leurs représentations en 2D.",
    text: "Représenter le développement d’un cube en dessinant le contour de toutes ses faces.",
  },
  {
    id: "MATH-P3-1d2dcfdc",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Établir des relations entre des objets en 3D et leurs représentations en 2D.",
    text: "Associer à un cube, un développement correct parmi des développements donnés.",
  },
  {
    id: "MATH-P3-bd13a10b",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Compétence",
    parent: "Articuler, en contexte, les caractéristiques, puis les propriétés des solides et des figures, les procédés de construction et de traçage.",
    text: "Tracer, sur papier tramé, une figure composée de figures travaillées suivant des consignes de construction.",
  },
  {
    id: "MATH-P3-be524dfb",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Compétence",
    parent: "En 3e année primaire, les premiers mouvements En 4e année primaire, les mouvements se complètent et les premiers agrandissements et réductions apparaissent.",
    text: "(glisser et retourner) sont rencontrés.",
  },
  {
    id: "MATH-P3-7e8998ba",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir",
    parent: "Des mouvements et leurs caractéristiques vers les isométries.",
    text: "Utiliser les termes « glisser », « retourner » pour décrire le mouvement appliqué à une figure.",
  },
  {
    id: "MATH-P3-06db1107",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Réaliser des mouvements sur des figures.",
    text: "Exécuter le mouvement (glissement, retournement) qui permet de passer d’un motif figuratif à son image donnée, avec un support (un gabarit, du papier calque...).",
  },
  {
    id: "MATH-P3-3b8cb468",
    champ: "CHAMP 1 : DES OBJETS DE L’ESPACE À LA GÉOMÉTRIE",
    section: "1.2. Appréhender et représenter des objets de l’espace",
    kind: "Savoir-faire",
    parent: "Réaliser des mouvements sur des figures.",
    text: "Tracer dans un quadrillage, selon l’axe de symétrie donné, l’image d’une figure.",
  },
  {
    id: "MATH-P3-67c057f2",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir",
    parent: "L’identification et la comparaison de grandeurs d’objets.",
    text: "Utiliser de manière adéquate les termes relatifs aux grandeurs : la longueur, la masse, la capacité, le cout.",
  },
  {
    id: "MATH-P3-9d0365e9",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir",
    parent: "L’identification et la comparaison de grandeurs d’objets.",
    text: "Énoncer la comparaison de deux objets selon une de leurs grandeurs.",
  },
  {
    id: "MATH-P3-dff10853",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir",
    parent: "L’identification et la comparaison de grandeurs d’objets.",
    text: "Utiliser de manière adéquate les termes : longueur, largeur, épaisseur, profondeur, hauteur et périmètre.",
  },
  {
    id: "MATH-P3-c377f79d",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir",
    parent: "La notion de durée et la comparaison de durées.",
    text: "Utiliser, en situation, le vocabulaire en référence à la durée en utilisant des expressions telles que : le temps utilisé pour…, telle activité dure…, la durée de…",
  },
  {
    id: "MATH-P3-c201999a",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir",
    parent: "La notion de durée et la comparaison de durées.",
    text: "Énoncer la comparaison de la durée de deux évènements, deux actions… avec les mots : dure plus, aussi, moins longtemps que…",
  },
  {
    id: "MATH-P3-95d01d00",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir-faire",
    parent: "Comparer des objets selon une de leurs grandeurs.",
    text: "Classer des récipients donnés selon leur capacité.",
  },
  {
    id: "MATH-P3-6591b8c5",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Savoir-faire",
    parent: "Comparer les durées d’évènements, d’actions.",
    text: "Trier des situations données évoquant des durées subjectives (ressenties) ou objectives. Comparer la durée de situations vécues (dure moins longtemps/plus longtemps/autant que…) en référence à une heure, à une ou plusieurs minute(s).",
  },
  {
    id: "MATH-P3-b06122e5",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.1. Concevoir des grandeurs",
    kind: "Compétence",
    parent: "Choisir, en situations significatives, des démarches pertinentes de comparaisons de grandeurs d’objets.",
    text: "Choisir une action concrète pertinente pour comparer des capacités (regarder, juxtaposer, transvaser…), verbaliser son action et expliquer son choix.",
  },
  {
    id: "MATH-P3-00aed927",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir",
    parent: "L’usage des unités conventionnelles.",
    text: "Utiliser et symboliser : - le mètre (m), le décimètre (dm), le centimètre (cm), le kilomètre (km) ; - le litre (l), le centilitre (cl) ; - le kilogramme (kg), le gramme (g) ; - l’euro (€) et les centimes.",
  },
  {
    id: "MATH-P3-b51854e6",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir",
    parent: "L’usage des unités conventionnelles.",
    text: "Distinguer dans l’expression d’une grandeur mesurée : la grandeur, la mesure et l’unité de mesure.",
  },
  {
    id: "MATH-P3-f1942bac",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir",
    parent: "Le mesurage de durées.",
    text: "Utiliser et symboliser la seconde (s), la minute (min), l’heure (h), le quart d’heure, la demi-heure, l’année.",
  },
  {
    id: "MATH-P3-98fda8d8",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir",
    parent: "Le mesurage de durées.",
    text: "Énoncer les relations entre certaines unités de durée : - 1 minute = 60 secondes ; - 1 heure = 60 minutes ; - 1 jour = 24 heures ; - 1 an = 365 (ou 366) jours.",
  },
  {
    id: "MATH-P3-abfdf974",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Mesurer des grandeurs.",
    text: "Effectuer le mesurage d’une aire d’un carré ou d’un rectangle à l’aide d’un étalon non conventionnel choisi (familier et commun à la classe) et en exprimer le résultat approximatif.",
  },
  {
    id: "MATH-P3-614f2ae6",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Mesurer des grandeurs.",
    text: "Effectuer le mesurage d’une longueur/d’une masse/d’une capacité d’objets de l’environnement et en exprimer le résultat en utilisant l’unité conventionnelle : - m, dm, cm, km ; - l, cl ; - kg, g.",
  },
  {
    id: "MATH-P3-18f22c45",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Mesurer des grandeurs.",
    text: "Utiliser l’instrument de mesure adéquat en fonction de la situation.",
  },
  {
    id: "MATH-P3-8d185ba0",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Mesurer des grandeurs.",
    text: "Lire l’heure sur un support analogique ou digital : - en heures et minutes ; - en heures, quart et demi-heure.",
  },
  {
    id: "MATH-P3-116857c1",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Utiliser des instruments, des supports pour exprimer un instant dans le temps et mesurer des durées.",
    text: "Utiliser une horloge analogique avec trotteuse pour déterminer la durée d’une action.",
  },
  {
    id: "MATH-P3-7fe46d35",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Choisir une grandeur et justifier son choix.",
    text: "Choisir parmi plusieurs estimations d’une capacité (en l ou en cl), d’une masse (en kg ou g), celle qui est la plus plausible et justifier son choix.",
  },
  {
    id: "MATH-P3-9fc468de",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Choisir une grandeur et justifier son choix.",
    text: "Choisir parmi plusieurs estimations de durées d’actions, données en minutes, celle qui est la plus plausible et justifier son choix.",
  },
  {
    id: "MATH-P3-7d7f15f5",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Construire le système des unités conventionnelles.",
    text: "Donner du sens aux unités conventionnelles travaillées en les associant à des objets de l’environnement.",
  },
  {
    id: "MATH-P3-64beb3e0",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Construire le système des unités conventionnelles.",
    text: "Lister des objets de la vie courante dont une grandeur se mesure avec l’unité travaillée.",
  },
  {
    id: "MATH-P3-d0bbfbb5",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Construire le système des unités conventionnelles.",
    text: "Réaliser des conversions significatives (longueur, masse, capacité) en lien avec les unités conventionnelles travaillées.",
  },
  {
    id: "MATH-P3-0042f4c5",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Savoir-faire",
    parent: "Donner du sens à des unités usuelles de durées.",
    text: "Associer une demi-heure, une heure, deux heures à la durée de situations vécues.",
  },
  {
    id: "MATH-P3-a2053d0b",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Articuler, en situations significatives, l’estimation d’une grandeur, son mesurage (avec les références et les outils adéquats) et l’appréciation du résultat.",
    text: "Rassembler et utiliser des instruments de mesure et des récipients adaptés et pertinents de capacité, de masse, de longueur pour mener à bien une tâche.",
  },
  {
    id: "MATH-P3-f64e3070",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Articuler, en situations significatives, l’estimation d’une grandeur, son mesurage (avec les références et les outils adéquats) et l’appréciation du résultat.",
    text: "Établir une collection d’au moins cinq objets de référence d’une mesure de grandeur donnée (longueur, capacité, masse, prix) en estimant, en mesurant ou en cherchant l’information, pour se créer des images mentales de ces mesures.",
  },
  {
    id: "MATH-P3-1bce4936",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Articuler, en situations significatives, l’estimation d’une grandeur, son mesurage (avec les références et les outils adéquats) et l’appréciation du résultat.",
    text: "Estimer la capacité d’un récipient en référence à une unité conventionnelle choisie (le litre, le centilitre) avant d’effectuer le mesurage par transvasements.",
  },
  {
    id: "MATH-P3-1a233e38",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Articuler, en situations significatives, l’estimation d’une grandeur, son mesurage (avec les références et les outils adéquats) et l’appréciation du résultat.",
    text: "Estimer, en soupesant, la masse d’un objet en référence à une unité conventionnelle choisie (le kilogramme, le gramme) avant d’effectuer le mesurage sur une balance.",
  },
  {
    id: "MATH-P3-6f8f6f4e",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Recourir à divers outils et stratégies pour anticiper, représenter, planifier, gérer le temps en fonction de divers buts.",
    text: "Estimer en minutes la durée d’une activité à vivre ou vécue.",
  },
  {
    id: "MATH-P3-4b934f98",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Recourir à divers outils et stratégies pour anticiper, représenter, planifier, gérer le temps en fonction de divers buts.",
    text: "Quantifier la durée nécessaire à la réalisation d’une activité connue et régulièrement vécue (en minutes mais ne dépassant pas une heure) pour en vérifier la faisabilité dans le laps de temps défini ou imparti.",
  },
  {
    id: "MATH-P3-32bb6117",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Résoudre des problèmes dans des situations contextualisées.",
    text: "Résoudre des problèmes d’achats mobilisant : - maximum trois articles ; - des prix exprimés en € et centimes (comme 1 € et 50 centimes).",
  },
  {
    id: "MATH-P3-d31ed35c",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.2. Agir sur des grandeurs",
    kind: "Compétence",
    parent: "Résoudre des problèmes dans des situations contextualisées.",
    text: "Résoudre des problèmes dans lesquels deux grandeurs sont en relation de proportionnalité directe. Ex. : la capacité et le nombre de récipients.",
  },
  {
    id: "MATH-P3-5f120bd4",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir",
    parent: "Les périmètres et les aires de figures, les volumes de solides.",
    text: "Énoncer que le périmètre d’une figure est la longueur de son contour.",
  },
  {
    id: "MATH-P3-db3d3252",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir",
    parent: "Les périmètres et les aires de figures, les volumes de solides.",
    text: "Énoncer le calcul du périmètre du rectangle et du carré.",
  },
  {
    id: "MATH-P3-bb27e748",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir",
    parent: "Les périmètres et les aires de figures, les volumes de solides.",
    text: "Énoncer que l’aire d’une figure est l’étendue de sa surface.",
  },
  {
    id: "MATH-P3-13d9e854",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir",
    parent: "Les périmètres et les aires de figures, les volumes de solides.",
    text: "Montrer le volume de solides.",
  },
  {
    id: "MATH-P3-15c6061b",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir-faire",
    parent: "Construire et utiliser des démarches pour calculer des périmètres, des aires de figures et des volumes de solides.",
    text: "Tracer dans un quadrillage, le contour déplié d’un rectangle ou d’un carré en identifiant chaque côté.",
  },
  {
    id: "MATH-P3-bdc2fe51",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir-faire",
    parent: "Construire et utiliser des démarches pour calculer des périmètres, des aires de figures et des volumes de solides.",
    text: "Calculer le périmètre, en cm, de polygones (rectangle, carré) donnés à partir des longueurs de côtés données ou mesurées (nombres entiers).",
  },
  {
    id: "MATH-P3-8700b845",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir-faire",
    parent: "Construire et utiliser des démarches pour calculer des périmètres, des aires de figures et des volumes de solides.",
    text: "Déterminer l’aire d’un polygone (rectangle, carré) donné dans : - un quadrillage en étalons non conventionnels (x cases du quadrillage) ; - un quadrillage en carrés dont le côté mesure 1 cm.",
  },
  {
    id: "MATH-P3-bcf52233",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Savoir-faire",
    parent: "Construire et utiliser des démarches pour calculer des périmètres, des aires de figures et des volumes de solides.",
    text: "Choisir les unités de mesure du périmètre adaptées à la situation.",
  },
  {
    id: "MATH-P3-547fbd22",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Compétence",
    parent: "Construire des démarches pour déterminer des périmètres, des aires et des volumes, en situations significatives.",
    text: "Résoudre des problèmes faisant intervenir des calculs de périmètre de figures simples, en situations contextualisées, et verbaliser sa démarche.",
  },
  {
    id: "MATH-P3-712a7ef8",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.3. Opérer sur des grandeurs – périmètres, aires et volumes",
    kind: "Compétence",
    parent: "Construire des démarches pour déterminer des variations en lien avec des calculs de périmètres, d’aires et de volumes.",
    text: "Résoudre des problèmes faisant intervenir des variations de dimensions d’un rectangle en respectant le même périmètre.",
  },
  {
    id: "MATH-P3-ec519c50",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir",
    parent: "Construire des démarches pour déterminer des variations en lien avec des calculs de périmètres, d’aires et de volumes.",
    text: "Utiliser de manière adéquate les expressions de grandeurs fractionnées plus petites ou égales à l’unité : 1/2, 1/4, 1/8, 2/3, 5/6 de…",
  },
  {
    id: "MATH-P3-a3d948c3",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir",
    parent: "La notion de fraction partage en lien avec des grandeurs d’objets (réels, représentés).",
    text: "Utiliser de manière adéquate les termes « numérateur » et « dénominateur » d’une fraction.",
  },
  {
    id: "MATH-P3-6ea05e22",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir",
    parent: "La notion de fraction partage en lien avec des grandeurs d’objets (réels, représentés).",
    text: "Énoncer les rôles du numérateur et du dénominateur d’une fraction au départ de l’unité.",
  },
  {
    id: "MATH-P3-43ab06ac",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir-faire",
    parent: "La notion de fraction partage en lien avec des grandeurs d’objets (réels, représentés).",
    text: "Fractionner : • des objets selon une de leurs grandeurs en tiers, en sixièmes, en huitièmes ; • des mesures de - longueurs : 1/2 m ; - capacités : 1/2 l, 1/4 l, 1/8 l ; - masses : 1/2 kg, 1/4 kg, 1/8 kg.",
  },
  {
    id: "MATH-P3-39b1688a",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir-faire",
    parent: "Exploiter des fractions partages et des pourcentages.",
    text: "Recomposer l’unité à partir de huitièmes, de tiers, de sixièmes.",
  },
  {
    id: "MATH-P3-c26ebb76",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir-faire",
    parent: "Exploiter des fractions partages et des pourcentages.",
    text: "Représenter des fractions partages plus petites ou égales à l’unité : 1/2, 1/4, 1/8, 2/3 et 5/6 de…",
  },
  {
    id: "MATH-P3-bdaae620",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir-faire",
    parent: "Exploiter des fractions partages et des pourcentages.",
    text: "Reconnaitre des représentations de fractions partages plus petites ou égales à l’unité : 1/2, 1/4, 1/8, 2/3 et 5/6 de…",
  },
  {
    id: "MATH-P3-ac799cd9",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir-faire",
    parent: "Exploiter des fractions partages et des pourcentages.",
    text: "Établir l’équivalence de fractionnements d’objets, de mesures de grandeurs et la traduire par une égalité.",
  },
  {
    id: "MATH-P3-c872eb09",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Savoir-faire",
    parent: "Comparer des grandeurs fractionnées pour établir des équivalences, pour établir un ordre.",
    text: "Établir l’ordre entre grandeurs fractionnées de même dénominateur.",
  },
  {
    id: "MATH-P3-514e8017",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.4. Agir puis opérer sur des grandeurs – fractions",
    kind: "Compétence",
    parent: "Comparer des grandeurs fractionnées pour établir des équivalences, pour établir un ordre.",
    text: "Résoudre des problèmes faisant intervenir des représentations de grandeurs fractionnées dans des situations contextualisées.",
  },
  {
    id: "MATH-P3-6c92ebee",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.5. Mettre en relation des grandeurs",
    kind: "Savoir-faire",
    parent: "Exploiter des situations de proportionnalité directe entre grandeurs.",
    text: "Déterminer une quantité dans une situation (vécue et manipulée ou contextualisée) de proportionnalité directe (nombre de… pour…).",
  },
  {
    id: "MATH-P3-c5ab6f22",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.5. Mettre en relation des grandeurs",
    kind: "Savoir-faire",
    parent: "Exploiter des situations de proportionnalité directe entre grandeurs.",
    text: "Représenter une situation vécue et manipulée de proportionnalité directe par un graphe fléché ou un tableau de proportionnalité.",
  },
  {
    id: "MATH-P3-901f278e",
    champ: "CHAMP 2 : DES GRANDEURS À LA RELATION ENTRE VARIABLES",
    section: "2.5. Mettre en relation des grandeurs",
    kind: "Savoir-faire",
    parent: "Exploiter des situations de proportionnalité directe entre grandeurs.",
    text: "Associer une situation de proportionnalité directe à un tableau de proportionnalité.",
  },
  {
    id: "MATH-P3-31807109",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "Des nombres naturels aux nombres réels.",
    text: "Utiliser des nombres pour communiquer : - une quantité ; - une position ; - un numéro ; - …",
  },
  {
    id: "MATH-P3-ce42fda2",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "Des nombres naturels aux nombres réels.",
    text: "Utiliser de manière adéquate les noms des rangs : unité, dizaine, centaine.",
  },
  {
    id: "MATH-P3-6bc641fe",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "Des nombres naturels aux nombres réels.",
    text: "Associer le nom d’un nombre (naturel jusqu’à 1 000) à son écriture en chiffres.",
  },
  {
    id: "MATH-P3-793097f8",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "Des nombres naturels aux nombres réels.",
    text: "Reconnaitre les nombres de 1 à 1 000 sous forme de centaines, de dizaines et d’unités.",
  },
  {
    id: "MATH-P3-d13f8926",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "Des nombres naturels aux nombres réels.",
    text: "Utiliser de manière adéquate les mots : - pair et impair ; - multiple et diviseur.",
  },
  {
    id: "MATH-P3-37629cdb",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "Les chaines numériques.",
    text: "Compter par 10, 20, 25, 50, 100, 200, 250 jusqu’à 1 000.",
  },
  {
    id: "MATH-P3-267553bb",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "De la comparaison de collections puis de nombres à la relation d’ordre.",
    text: "Utiliser de manière adéquate les termes liés à la cardinalité : - égal à, le même nombre que, autant que ; - moins que, plus petit que, autant en moins que ; - plus que, plus grand que, autant en plus que ; - vaut autant de fois ; - vaut le double/la moitié, le quadruple/le quart de…",
  },
  {
    id: "MATH-P3-e5335927",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "De la comparaison de collections puis de nombres à la relation d’ordre.",
    text: "Associer les symboles d’ordre (<, >, =) aux expressions « est plus petit que », « est plus grand que », « est égal à ».",
  },
  {
    id: "MATH-P3-24be9ceb",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir",
    parent: "De la comparaison de collections puis de nombres à la relation d’ordre.",
    text: "Utiliser de manière adéquate les termes liés à l’ordinalité des nombres naturels : - avant, après, entre, juste avant, juste après ; - premier, deuxième... dernier.",
  },
  {
    id: "MATH-P3-a2cb0ac6",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Dire, lire, écrire et représenter les nombres dans la numération décimale.",
    text: "Dire, lire des nombres jusqu’à 1 000 et les écrire en chiffres.",
  },
  {
    id: "MATH-P3-72a04142",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Dire, lire, écrire et représenter les nombres dans la numération décimale.",
    text: "Expliquer la présence du zéro dans l’écriture des nombres jusqu’à 1 000.",
  },
  {
    id: "MATH-P3-d14f5ecd",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Dire, lire, écrire et représenter les nombres dans la numération décimale.",
    text: "Représenter des nombres jusqu’à trois chiffres : - avec du matériel de comptage ; - en centaines, dizaines et unités.",
  },
  {
    id: "MATH-P3-c3a7f265",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Dénombrer des collections à organiser.",
    text: "Dénombrer des collections en comptant : - par 10, par 20, par 25, par 50 jusqu’à 200 ; - par 100, par 200, par 250 jusqu’à 1 000 et cardinaliser la totalité.",
  },
  {
    id: "MATH-P3-5180c39c",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Décomposer et recomposer les nombres.",
    text: "Décomposer et recomposer des nombres de 1 à 1 000 en lien avec la numération décimale. Ex. : 764 c’est 7 C et 6 D et 4 U.",
  },
  {
    id: "MATH-P3-78ceade0",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Décomposer et recomposer les nombres.",
    text: "Décomposer et recomposer des nombres jusqu’à 1 000 en deux termes, de manière non ordonnée.",
  },
  {
    id: "MATH-P3-8285366d",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Décomposer et recomposer les nombres.",
    text: "Décomposer et recomposer le nombre 1 000 : - additivement ; - multiplicativement.",
  },
  {
    id: "MATH-P3-0456f787",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Comparer, ordonner, situer des nombres.",
    text: "Utiliser le vocabulaire adéquat et les signes \"<\", \">\" et \"=\" pour exprimer la comparaison de deux nombres.",
  },
  {
    id: "MATH-P3-e8063d05",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Comparer, ordonner, situer des nombres.",
    text: "Ordonner des nombres (de 1 à 1 000) de façon croissante ou décroissante.",
  },
  {
    id: "MATH-P3-fe8fc5f6",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Comparer, ordonner, situer des nombres.",
    text: "Placer un nombre donné jusqu’à 1 000 : - sur une portion de droite numérique graduée ; - dans une portion de tableau.",
  },
  {
    id: "MATH-P3-0ef97290",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Comparer, ordonner, situer des nombres.",
    text: "Exprimer la position d’un nombre jusqu’à 1 000 (par encadrement, par approximation selon un degré de précision donné) sur une portion de droite numérique.",
  },
  {
    id: "MATH-P3-2efa995b",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Comparer, ordonner, situer des nombres.",
    text: "Compléter des portions d’un tableau numérique où sont donnés quelques nombres (jusqu’à 100 ou jusqu’à 1 000).",
  },
  {
    id: "MATH-P3-33b67b82",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Créer des familles de nombres, relever des régularités.",
    text: "Représenter les tables de multiplication par 4, par 3 et par 6 (T4, T3, T6) : - à partir de situations ; - avec des dessins ; - en mots ; - en calculs (additions réitérées et multiplications).",
  },
  {
    id: "MATH-P3-309f7eb7",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Créer des familles de nombres, relever des régularités.",
    text: "Exprimer, de diverses manières, les régularités observées au sein de : - T2, T4 et les lier ; - T3, T6 et les lier.",
  },
  {
    id: "MATH-P3-c53d65e3",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Créer des familles de nombres, relever des régularités.",
    text: "Déterminer la régularité présente dans une suite de nombres donnée.",
  },
  {
    id: "MATH-P3-0c133460",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.1. Appréhender le nombre puis la lettre dans tous leurs aspects",
    kind: "Savoir-faire",
    parent: "Créer des familles de nombres, relever des régularités.",
    text: "Ajouter au moins trois éléments à une suite de nombres donnée.",
  },
  {
    id: "MATH-P3-2312fa9c",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir",
    parent: "Les opérations et leurs propriétés.",
    text: "Associer l’opération à son symbole : - addition, « + » ; - soustraction, « - » ; - multiplication, « x » ; - division, « : ».",
  },
  {
    id: "MATH-P3-b2e49a09",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir",
    parent: "Les opérations et leurs propriétés.",
    text: "Associer le symbole « = » à l’expression « est égal à » et le symbole « ≠ » à l’expression « n’est pas égal à » ou « est différent de ».",
  },
  {
    id: "MATH-P3-4f77af17",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir",
    parent: "Les opérations et leurs propriétés.",
    text: "Reconnaitre les parenthèses comme symbole intervenant dans des procédures de calcul.",
  },
  {
    id: "MATH-P3-6eb75fa1",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir",
    parent: "Les automatismes de base en calcul.",
    text: "Connaitre de mémoire : - les tables d’addition des dix premiers nombres ; - les décompositions de 100 en deux termes ou en deux facteurs.",
  },
  {
    id: "MATH-P3-5a2acf69",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir",
    parent: "Les automatismes de base en calcul.",
    text: "Connaitre de mémoire les tables de multiplication T2, T4, T5, T10, T3 et T6.",
  },
  {
    id: "MATH-P3-11b15a19",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Construire le sens des opérations.",
    text: "Utiliser, en situations concrètes, le vocabulaire familier lié aux quatre opérations. Ex. : - Ajouter, augmenter de, avancer de, monter de, mettre en plus… - Regrouper, rassembler, mettre ensemble, mettre avec… - Reculer, enlever, retirer, cacher, perdre… - Chercher l’écart, la différence… - Faire des tas, des paquets, des piles de… - Prendre plusieurs fois… - Partager, répartir en… tas, distribuer à…",
  },
  {
    id: "MATH-P3-53c4833e",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Appréhender et utiliser l’égalité.",
    text: "Utiliser l’égalité en termes de résultat : addition et soustraction jusqu’à 1 000, multiplication et division jusqu’à 100.",
  },
  {
    id: "MATH-P3-ff54b306",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Appréhender et utiliser l’égalité.",
    text: "Utiliser l’égalité en termes d’équivalence : nombres jusqu’à 100. Ex. : 72 + 17 = 89 89 = 72 + 17 72 + 17 = 90 - 1",
  },
  {
    id: "MATH-P3-1c3b43d0",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Appréhender et utiliser l’égalité.",
    text: "Utiliser l’égalité adéquatement dans les enchainements opératoires. Ex. : 12 x 5 = (12 x 10) : 2 = 120 : 2 = 60",
  },
  {
    id: "MATH-P3-6c450714",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Appréhender et utiliser l’égalité.",
    text: "Ajuster les fausses égalités pour qu’elles deviennent vraies. Ex. : 12 + 23 = 35 + 2 = 37 devient 12 + 23 = 35 35 + 2 = 37 ou (12 + 23) + 2 = 37",
  },
  {
    id: "MATH-P3-c5a28478",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Utiliser les propriétés des opérations pour remplacer un calcul par un autre plus simple.",
    text: "Utiliser la commutativité de l’addition et de la multiplication.",
  },
  {
    id: "MATH-P3-9a7e0189",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Utiliser les propriétés des opérations pour remplacer un calcul par un autre plus simple.",
    text: "Utiliser l’associativité de l’addition et de la multiplication.",
  },
  {
    id: "MATH-P3-d467c13a",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Utiliser des procédures de calcul mental pour trouver le résultat plus facilement.",
    text: "Utiliser, pour effectuer une opération, une technique parmi : - la décomposition ; - la distributivité ; - la compensation.",
  },
  {
    id: "MATH-P3-8a530fe5",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Utiliser des procédures de calcul mental pour trouver le résultat plus facilement.",
    text: "Utiliser la comparaison des nombres pour effectuer une opération. Ex. : Si 6 x 12 = 72 alors 60 x 12 = …",
  },
  {
    id: "MATH-P3-75c33488",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Utiliser des procédures de calcul mental pour trouver le résultat plus facilement.",
    text: "Effectuer des multiplications spécifiques par 10, par 100, par 20, par 4 et par 8.",
  },
  {
    id: "MATH-P3-5322e637",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Utiliser des procédures de calcul mental pour trouver le résultat plus facilement.",
    text: "Effectuer des divisons spécifiques par 10 et par 4.",
  },
  {
    id: "MATH-P3-ad0efb0a",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Appliquer un algorithme de calcul écrit pour en comprendre le mécanisme.",
    text: "Effectuer des additions limitées à trois termes.",
  },
  {
    id: "MATH-P3-f4e4c206",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Appliquer un algorithme de calcul écrit pour en comprendre le mécanisme.",
    text: "Effectuer des soustractions (technique de l’emprunt et/ou de la compensation).",
  },
  {
    id: "MATH-P3-165b1cba",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Estimer et vérifier.",
    text: "Estimer l’ordre de grandeur du résultat d’une opération (addition et soustraction), avant de calculer précisément.",
  },
  {
    id: "MATH-P3-9f1a2d6d",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Estimer et vérifier.",
    text: "Vérifier la plausibilité d’un résultat.",
  },
  {
    id: "MATH-P3-048ecd5f",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Estimer et vérifier.",
    text: "Utiliser la calculatrice pour vérifier le résultat d’une opération (addition, soustraction, multiplication).",
  },
  {
    id: "MATH-P3-b9067930",
    champ: "CHAMP 3 : DE L’ARITHMÉTIQUE À L’ALGÈBRE",
    section: "3.2. Opérer sur des nombres et sur des expressions algébriques",
    kind: "Savoir-faire",
    parent: "Estimer et vérifier.",
    text: "Utiliser les opérations réciproques (+, -) et (x, :) pour vérifier le résultat d’une opération.",
  },
  {
    id: "MATH-P3-3ab6a10a",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir",
    parent: "L’organisation d’objets, de données.",
    text: "Utiliser les mots : - trier : « a ou n’a pas …» (selon le critère défini) ; Ex. : la couleur. - classer (selon des caractéristiques définies au sein d’un critère) ; Ex. : rouge, jaune, bleu…",
  },
  {
    id: "MATH-P3-d1cf8cb0",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir",
    parent: "L’organisation d’objets, de données.",
    text: "Reconnaitre une représentation de données en : - tableau ; - ensembles ; - arbre (dichotomique) ; - diagramme à bandes.",
  },
  {
    id: "MATH-P3-251a9afa",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir-faire",
    parent: "Recueillir des informations.",
    text: "Collecter des informations à partir d’une question : - exigeant une réponse par oui ou par non ; - permettant un classement des données récoltées.",
  },
  {
    id: "MATH-P3-429f4292",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir-faire",
    parent: "Trier, classer des objets ou des données.",
    text: "Organiser des objets représentés et des données : - par tri selon deux critères considérés successivement ; - par classement selon des caractéristiques déterminées au sein d’un critère.",
  },
  {
    id: "MATH-P3-46133099",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir-faire",
    parent: "Trier, classer des objets ou des données.",
    text: "Déterminer les critères appliqués dans l’organisation d’objets représentés.",
  },
  {
    id: "MATH-P3-bba45e06",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir-faire",
    parent: "Trier, classer des objets ou des données.",
    text: "Choisir, pour organiser des objets représentés : - un critère à appliquer à un tri ; - un critère et au moins deux caractéristiques à appliquer à un classement.",
  },
  {
    id: "MATH-P3-294f0524",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Savoir-faire",
    parent: "Présenter des données.",
    text: "Compléter le support donné en fonction de la situation pour représenter un tri ou un classement : - deux ensembles incluant une intersection ; - un arbre dichotomique (deux critères) ; - un tableau à double entrée ; - un diagramme à bandes horizontales ou verticales.",
  },
  {
    id: "MATH-P3-d2b9355b",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Compétence",
    parent: "Lire et interpréter des données pour en extraire de l’information.",
    text: "Prélever des informations issues d’une représentation : - de deux ensembles incluant une intersection ; - d’un arbre dichotomique (deux critères) ; - d’un tableau à double entrée ; - d’un diagramme à bandes horizontales ou verticales.",
  },
  {
    id: "MATH-P3-464dc6cb",
    champ: "CHAMP 4 : DE L’ORGANISATION DES DONNÉES À LA STATISTIQUE",
    section: "4.1. Collecter, organiser, représenter et interpréter des données",
    kind: "Compétence",
    parent: "Résoudre des problèmes en utilisant les données prélevées.",
    text: "Résoudre des problèmes de logique déductive en complétant un tableau à double entrée limité à seize cases.",
  },
];
